
/*
 *
 * Date: 2025
 * Description: Search listing component.
 * Author: Philippe Leroux @SKITSC
 *
 */

//Modules
import { ReactElement } from "react";
import { Box, Typography } from "@mui/material";

//Interfaces
import { i_part_search } from "../../interfaces/items.interface";
import { i_side_bar_bottom_props } from "../../interfaces/display.interfaces";

//Utils
import { formatTimestamp } from "../../utils/utility";


const SideBarBottom = ( props : i_side_bar_bottom_props) : ReactElement => {
    const renderSearch = ( search : i_part_search ) : ReactElement => {
        return(
            search.sku !== '' ?
            <Box sx={{ marginBottom : '5px', cursor : 'pointer'}} onClick={() => props.callback(search)}>
                <Typography>{ search.sku + " - " + formatTimestamp(search.timestamp)}</Typography>
            </Box> 
            :
            <Box sx={{  marginBottom : '5px' , cursor : 'pointer'}} onClick={() => props.callback(search)}>
                <Typography sx={{ textDecoration : 'underline' , fontSize : 14 }}>{ search.make + " " + search.model + ' ' + search.year + ' ' +  formatTimestamp(search.timestamp)} </Typography>
            </Box> 
        )
    }
    return(
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '500px' }}>
            <Box sx={{ marginBottom : '1vh' , marginTop : '1vh' , borderTop : '1px solid black'}}>
                <Typography sx={{ marginTop : '1vh' , fontWeight : '700'}}>
                    Latest catalog search..
                </Typography>
            </Box>
            <Box sx={{ flex: 1, overflowY: 'auto' }}>
                {props.search.map((search : i_part_search , index : number) => (
                    <Box key={index}>
                        {renderSearch(search)}
                    </Box>
                ))}
            </Box>
        </Box>
    )
}
export default SideBarBottom